var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('news-list-vue',{staticClass:"news-magazine-wrapper",attrs:{"intranet-uid":_vm.intranetUid}})}
var staticRenderFns = []

export { render, staticRenderFns }